import styled, { css } from 'styled-components';
const colorSchemes = {
    grey: {
        background: '#EBEBEB',
        textColor: '#898989',
    },
    green: {
        background: '#E4FBE5',
        textColor: '#4AC326'
    },
    red: {
        background: '#FDEBEB',
        textColor: '#FD4949'
    },
    blue: {
        background: '#EBEEFD',
        textColor: '#1F35B5'
    },
};
export const BadgeWrapper = styled.div `
  font-family: 'Ubuntu';

   ${({ colorScheme }) => colorScheme &&
    colorSchemes[colorScheme] &&
    css `
      width: max-content;
      padding: 3px 5px;
      border-radius: 5px;
      color: ${colorSchemes[colorScheme].textColor};
      background: ${colorSchemes[colorScheme].background};
   `}
`;
//# sourceMappingURL=styles.js.map